<template>
    <p ref="subtitle" class="text-gray-600">
        {{ truncate(subtitle, maxSubtitleLength, "...") }}
    </p>
</template>

<script>
export default {
name: "CollapsableText",
props: {
    title: {
        required: true,
        type: String,
    },
    subtitle: {
        required: false,
        type: String,
    },
    link: {
        required: false,
        type: String,
    },
    maxSubtitleLength: {
        required: false,
        type: Number,
        default: 200,
    },
},

methods: {
    /**
     * Truncates the text of a string if larger than the max length of it
     *
     * @param {String} text to be truncated
     * @param {Integer} length - trunctation point
     * @param {String} suffix - suffix to add to the string when truncated
     *
     * @returns {String} truncated string
     */
    truncate: function(text, length, suffix) {
        if (text.length > length) {
            return (
                text
                    .substring(0, length)
                    .trim()
                    .replace(/\.+$/, "") + suffix
            );
        }
        return text;
    },
},
};
</script>
